import { apiSlice, TAG_TYPES } from "../../features/api/apiSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: ({ id, values }) => ({
        url: `/user/changePassword/${id}`,
        method: "PATCH",
        body: values,
      }),
    }),
    verifyEmail: builder.mutation({
      query: ({ otp, email }) => ({
        url: `/user/verifyEmail/${otp}/${email}`,
        method: "PUT",
      }),
    }),
    forgotPassword: builder.mutation({
      query: ({ email }) => ({
        url: `/user/forgotPassword/${email}`,
        method: "GET",
      }),
    }),
    getVisitGPProfile: builder.query({
      query: ({ userId, viewerId }) =>
        `/user/VisitGPProfile?userId=${userId}&viewerId=${viewerId}`,
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TAG_TYPES.USER_INFO, id: arg.userId },
              { type: TAG_TYPES.VISIT_PROFILE, id: arg.userId },
            ]
          : [
              { type: TAG_TYPES.USER_INFO },
              { type: TAG_TYPES.VISIT_PROFILE },
            ],
    }),
    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/id/?id=${id}`,
        method: "PUT",
        body: data,
      }),
      // Invalidate both UserInfo and VisitProfile so other-profile pages
      // automatically refetch fresh data (images, cover, intro) without a page refresh
      invalidatesTags: (result, error, { id }) => [
        { type: TAG_TYPES.USER_INFO, id },
        { type: TAG_TYPES.USER },
        { type: TAG_TYPES.VISIT_PROFILE, id },
      ],
    }),
  }),
});

export const {
  useChangePasswordMutation,
  useVerifyEmailMutation,
  useForgotPasswordMutation,
  useGetVisitGPProfileQuery,
  useUpdateUserMutation,
} = userApi;
